document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.press-release-section').forEach(function (container) {
    const selectEl = container.querySelector('select');
    const button = container.querySelector('button');

    if (!selectEl || !button) return;

    button.addEventListener('click', function () {
      const selectedOption = selectEl.options[selectEl.selectedIndex];
      const url = selectedOption && selectedOption.value;
      if (url) {
        window.open(url, '_blank');
      } else {
        alert('Please select a document to download.');
      }
    });
  });
});
